<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="0.5" y="0.5" width="19" height="19" rx="9.5" stroke="#F16A6A"/>
<path d="M13 7L7 13" stroke="#F16A6A" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M7 7L13 13" stroke="#F16A6A" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
